<template>
  <div class="identity-document-input">
    <input type="file" accept="image/*" @change="onChange" />
    <input
      type="hidden"
      :value="uploadedFileValue"
      :name="setting.name"
      v-if="uploadedFileValue.length > 0"
    />
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import 'blueimp-canvas-to-blob';
import DirectUploader from '../lib/direct_uploader';
import { loadImageAsync, resizeImage } from '../lib/image';

export default {
  name: 'IdentityDocumentInput',
  props: {
    setting: {
      type: Object,
      default: function () {
        return {
          directUploadUrl: '',
          name: '',
        };
      },
    },
    isAttached: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadedFileValue: '',
    };
  },
  mounted() {
    if (this.isAttached) {
      this.$emit('attached');
    }
  },
  methods: {
    async onChange(event) {
      const file = event.target.files[0];
      try {
        if (!file.type.includes('image/')) {
          throw new Error('File does not match image');
        }

        // 画像をリサイズする（最大幅と高さを1980pxに設定）
        const resizedFile = await resizeImage(file, 1980, 1980);

        // リサイズした画像をキャンバスにプレビュー表示
        const image = await loadImageAsync(URL.createObjectURL(resizedFile));
        const canvas = this.$refs.canvas;
        canvas.width = image.width;
        canvas.height = image.height;
        canvas
          .getContext('2d')
          .drawImage(image, 0, 0, image.width, image.height);

        // リサイズした画像をアップロード
        this.upload(canvas);
      } catch (e) {
        console.error(e);
      }
    },
    upload(canvas) {
      canvas.toBlob(
        async (blob) => {
          blob.name = `${new Date().getTime()}.jpg`;
          try {
            const uploader = new DirectUploader(
              blob,
              this.setting.directUploadUrl
            );
            const uploaded = await uploader.upload();
            // console.log(uploaded);
            this.uploadedFileValue = uploaded.signed_id;
            this.$emit('attached');
          } catch (e) {
            console.error(e);
          }
        },
        'image/jpeg',
        0.95
      );
    },
  },
};
</script>

<style scoped lang="scss">
.identity-document-input {
  canvas {
    display: none;
  }
}
</style>
